import { ApiType } from "@gymflow/common";
import { QueryKey } from "@tanstack/react-query";

export const memberAsMemberQueryKeys = {
  all: () => ["memberAsMember"] as QueryKey,
  details: (memberId?: string) =>
    [...memberAsMemberQueryKeys.all(), memberId, "details"] as QueryKey,
  paymentMethods: (clubId: number, memberId?: string) =>
    [
      ...memberAsMemberQueryKeys.all(),
      memberId,
      "paymentMethods",
      clubId,
    ] as QueryKey,
  invoice: (invoiceNumber: unknown) =>
    [...memberAsMemberQueryKeys.all(), "invoice", invoiceNumber] as QueryKey,
  invoices: (filters?: Readonly<{ [k: string]: any }>) =>
    [...memberAsMemberQueryKeys.all(), "invoices", filters] as QueryKey,
  invoiceFile: (clubId: number, invoiceNumber: string) =>
    [
      ...memberAsMemberQueryKeys.all(),
      "invoiceFile",
      clubId,
      invoiceNumber,
    ] as QueryKey,
  paymentMethodsNew: (clubId: number, memberId: string) =>
    [
      ...memberAsMemberQueryKeys.all(),
      "paymentMethodsNew",
      clubId,
      memberId,
    ] as QueryKey,
  invoicesNew: (filters?: { [k: string]: any }) => {
    const result = [...memberAsMemberQueryKeys.all(), "invoicesNew"];
    if (filters) result.push(filters);
    return result as QueryKey;
  },
  highlightedInvoice: () => [
    ...memberAsMemberQueryKeys.all(),
    "invoicesNew",
    "highlightedInvoice",
  ],
  paymentMethodSetupIntent: (memberId?: string) =>
    [
      ...memberAsMemberQueryKeys.details(memberId),
      "paymentMethodSetupIntent",
    ] as QueryKey,
  sessionPackUsage: (
    params?: Parameters<ApiType["profileApi"]["sessionPackUsage"]>[0],
  ) =>
    [...memberAsMemberQueryKeys.all(), "sessionPackUsage", params] as QueryKey,
  getCurrentMembershipSubscription: () =>
    [
      ...memberAsMemberQueryKeys.all(),
      "getCurrentMembershipSubscription",
    ] as QueryKey,
  subscriptionChangeAvailableMemberships: (subscriptionId: number) => {
    const result = [
      ...memberAsMemberQueryKeys.all(),
      subscriptionId,
      "subscriptionChangeAvailableMemberships",
    ];
    return result as QueryKey;
  },
  subscriptionChangeCalculateScheduleDates: (
    params?: Parameters<
      ApiType["profileApi"]["subscriptionChangeCalculateScheduleDates"]
    >[0],
  ) =>
    [...memberAsMemberQueryKeys.all(), "sessionPackUsage", params] as QueryKey,
  getInvoiceByInvoiceNumber: (
    params?: Parameters<ApiType["profileApi"]["getInvoiceByInvoiceNumber"]>[0],
  ) =>
    [
      ...memberAsMemberQueryKeys.all(),
      "getInvoiceByInvoiceNumber",
      params,
    ] as QueryKey,
  getMembershipSubscriptionPrevious: () => {
    const result = [
      ...memberAsMemberQueryKeys.all(),
      "getMembershipSubscriptionPrevious",
    ];
    return result as QueryKey;
  },
  profile: () => [...memberAsMemberQueryKeys.all(), "profile"] as QueryKey,
};
